// extracted by mini-css-extract-plugin
export var chevron = "_go-2";
export var dropdownItems = "_go-0";
export var item = "_go-1";